// Workaround for the fact that React does not allow us to add these functions with a hook, we instantiate these in the App.js file then call them in the interceptors
let navigateFn = null;

export const setNavigator = (navigate) => {
  navigateFn = navigate;
};

export const navigate = (...args) => {
  if (navigateFn) {
    navigateFn(...args);
  }
};
